export const AGENTIC_CHAT_PANEL_STORAGE_KEY = 'agenticPanelOpen';
export const AGENTIC_CHAT_SESSION_STORAGE_KEY = 'agenticChatSession';
export const AGENTIC_CHAT_MODEL_STORAGE_KEY = 'agenticChatModel';

export const AGENTIC_CHAT_CONVERSATION_STARTERS: readonly string[] = [
  'How do I create a project and add a floor?',
  'Why can\'t I add a capture session?',
  'What\'s the difference between User, Support, and Admin?',
];
